export const fetchSupplierConfigurationRecords = (supplierconfig) => {
  // Return action
  return {
    // Unique identifier
    type: 'GET_SUPPLIERCONFIG',
	supplierconfig: supplierconfig
  }
};
